import { z } from "zod";
import { BaseStatisticsOutputItemSchema } from "@/Schemas/Statistics/BaseStatisticsOutputItem";

export const StatisticsProcessingOutputSchema = z.object({
    items: z.array(BaseStatisticsOutputItemSchema),
});

export type StatisticsProcessingOutput = z.infer<typeof StatisticsProcessingOutputSchema>;